import { useSubscriptionStatusQuery } from "@/hooks";
import formatPrice from "@/lib/formatPrice";
import styles from "@/styles/Price.module.scss";

export default function FormatWatchPrice({
  price,
  type,
  ext,
  isLoggedIn,
  // discountPrice,
  discountFlag,
  course,
}) {
  const {
    data,
    loading: loadingSubscriptionStatus,
  } = useSubscriptionStatusQuery({
    variables: { courseId: Number(course?.id) },
  });

  if (isLoggedIn && loadingSubscriptionStatus) {
    return null;
  }

  const isTrialEnabled = isLoggedIn
    ? data?.subscriptionStatus?.is_trial_enabled
    : true;
  const showDiscount = isLoggedIn && discountFlag;
  const showTrial = isTrialEnabled && course?.trial_flag;

  if (
    type === "svod" &&
    !showTrial &&
    !course?.valuePlan /* && !showDiscount */
  ) {
    return (
      <div className={styles.watchPrice}>
        <div className={styles.watchPrices}>
          <div className={styles.priceLeft}>月額</div>
          <div className={styles.priceRight}>
            <span className={styles.priceAmount}>{formatPrice(price)}円</span>
            （税込）{ext}
          </div>
        </div>
      </div>
    );
  }
  // else if (type === "svod" && !showTrial && showDiscount) {
  //   return (
  //     <div className={styles.watchPrice}>
  //       <div className={styles.watchPrices}>
  //         <div className={styles.priceLeft}>月額</div>
  //         <div className={styles.priceRight}>
  //           <span className={styles.priceAmount}>{formatPrice(price)}円</span>
  //           （税込）
  //         </div>
  //       </div>
  //       <div className={styles.discountLink}>
  //         <p>
  //           ※対象のスカパー！放送商品をご購入の場合、割引適用となる商品です。割引適用となる商品の組み合わせは
  //           <Link
  //             href={routes.campaignWithBroadcast}
  //             target="_blank"
  //             rel="noopener noreferrer">

  //               こちら

  //           </Link>
  //           をご確認ください
  //           <br />
  //           ※対象の放送商品をご購入中の方は月額
  //           {formatPrice(discountPrice)}円(税込){ext}{" "}
  //         </p>
  //       </div>
  //     </div>
  //   );
  // }
  else if (
    type === "svod" &&
    showTrial &&
    !course?.valuePlan /* && !showDiscount */
  ) {
    return (
      <div className={`${styles.watchPrice} ${styles.trialFlag}`}>
        <div className={styles.trialDurationArea}>
          <span className={styles.slate}>
            <span className={styles.bold}>
              【初回購入限定】{course.trialTermText}
            </span>
          </span>
          <br />
          {course.trialText}期間後は月額
          <span className={styles.bold}>{formatPrice(price)}</span>
          円（税込）{ext}
        </div>
      </div>
    );
  } else if (type === "svod" && course?.valuePlan) {
    return null;
  }
  // else if (type === "svod" && showTrial && showDiscount) {
  //   return (
  //     <div className={`${styles.watchPrice} ${styles.trialFlag}`}>
  //       <div className={styles.trialDurationArea}>
  //         <span className={styles.slate}>
  //           <span className={styles.bold}>
  //             【初回購入限定】{course.trialTermText}
  //           </span>
  //         </span>
  //         <br />
  //         {course.trialText}期間後は月額
  //         <span className={styles.bold}>{formatPrice(price)}</span>
  //         円（税込）{ext}
  //         {course.valuePlan && (
  //           <div>
  //             {course.trialTermText}についての詳細は
  //             <Link
  //               href={routes.valuePlanCampaignDetail}
  //               target="_blank"
  //               rel="noopener noreferrer">

  //                 こちら

  //             </Link>
  //             からご確認ください。
  //           </div>
  //         )}
  //       </div>
  //       <div className={styles.discountLink}>
  //         <p>
  //           ※対象のスカパー！放送商品をご購入の場合、割引適用となる商品です。割引適用となる商品の組み合わせは
  //           <Link
  //             href={routes.campaignWithBroadcast}
  //             target="_blank"
  //             rel="noopener noreferrer">

  //               こちら

  //           </Link>
  //           をご確認ください。
  //           <br />
  //           ※対象の放送商品をご購入中の方は月額
  //           {formatPrice(discountPrice)}円(税込){ext}{" "}
  //         </p>
  //       </div>
  //     </div>
  //   );
  // }
  else if (type === "tvod" /* && !showDiscount */) {
    return (
      <div className={styles.watchPrice}>
        <div className={styles.watchPrices}>
          <div className={styles.priceLeft}>金額</div>
          <div className={styles.priceRight}>
            <span className={styles.priceAmount}>{formatPrice(price)}円</span>
            （税込）{ext}
          </div>
        </div>
      </div>
    );
  }
  // else if (type === "tvod" && showDiscount) {
  //   return (
  //     <div className={styles.watchPrice}>
  //       <div className={styles.watchPrices}>
  //         <div className={styles.priceLeft}>金額</div>
  //         <div className={styles.priceRight}>
  //           <span className={styles.priceAmount}>{formatPrice(price)}円</span>
  //           （税込）
  //           <span className={styles.discountLink}>
  //             ※対象のスカパー！放送商品をご購入の場合、割引適用となる商品です。割引適用となる商品の組み合わせは
  //             <Link
  //               href={routes.campaignWithBroadcast}
  //               target="_blank"
  //               rel="noopener noreferrer">

  //                 こちら

  //             </Link>
  //             をご確認ください
  //             <br />
  //             ※対象の放送商品をご購入中の方は{formatPrice(discountPrice)}
  //             円(税込){ext}
  //           </span>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }
}
